import stylesheet_10 from '../stylesheets/10.js';
import stylesheet_16 from '../stylesheets/16.js';
import stylesheet_15 from '../stylesheets/15.js';
import stylesheet_17 from '../stylesheets/17.js';
import stylesheet_14 from '../stylesheets/14.js';
import stylesheet_12 from '../stylesheets/12.js';
import stylesheet_11 from '../stylesheets/11.js';

export const index = 13;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/services/international-students/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/13.85276202.js","_app/immutable/chunks/scheduler.cba25ae0.js","_app/immutable/chunks/index.e8799153.js","_app/immutable/chunks/Wrapper.5a8cf0a2.js","_app/immutable/chunks/Hero.4ba03ae5.js","_app/immutable/chunks/each.4a3b5091.js","_app/immutable/chunks/ContentCard.442de305.js","_app/immutable/chunks/Roadmap.0f1444e1.js","_app/immutable/chunks/Image.b2849e64.js","_app/immutable/chunks/Button.c26d1de8.js","_app/immutable/chunks/BookOpenPageVariant.2cd2e754.js","_app/immutable/chunks/CastEducation.5921cb38.js","_app/immutable/chunks/Turbine.0170cb5f.js"];
export const stylesheets = ["_app/immutable/assets/13.7ea1ae3f.css","_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Hero.71a30b75.css","_app/immutable/assets/ContentCard.378eb474.css","_app/immutable/assets/Roadmap.0ad4251b.css","_app/immutable/assets/Image.1c236230.css","_app/immutable/assets/Button.4c43b995.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/13.7ea1ae3f.css": stylesheet_10,
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_16,
	"_app/immutable/assets/Hero.71a30b75.css": stylesheet_15,
	"_app/immutable/assets/ContentCard.378eb474.css": stylesheet_17,
	"_app/immutable/assets/Roadmap.0ad4251b.css": stylesheet_14,
	"_app/immutable/assets/Image.1c236230.css": stylesheet_12,
	"_app/immutable/assets/Button.4c43b995.css": stylesheet_11
});
